// ─────────────────────────────────────────────────────────────────────────────
// FINDLEY ST — WORK / SHOWROOM DATA
// Data-driven: to add a project, append an entry. To reorder, change `order`
// (lower = earlier). Nothing in the layout hard-codes position or count.
//
// media slots: hero / desktop / mobile / video / customer / backend
//   → null renders a clearly labeled, easy-to-replace placeholder frame.
//   → set to "/api/files/<storage-path>" (or any URL) when real media lands.
// kind: "template" (standardized Findley St build, backend command center
//   included) or "custom-system" (tailor-made, e.g. Holistic Ame).
// status: "live" | "demo-prep" | "in-preparation"
// purchaseEligible gates the Make This Yours block.
// Pricing: priceOnce / priceMonthly are the DISPLAY mirror of the authoritative
// backend catalog (/app/backend/catalog.py). Update both when prices change.
// WaaS is never below $150/month; no ranges, no invented numbers.
// ─────────────────────────────────────────────────────────────────────────────

export const PROJECTS = [
  {
    slug: "cory-suggs",
    order: 5,
    name: "Personal Brand Site",
    kind: "custom-system",
    category: "Personal Brand Site + Booking + Notes Wall",
    headline: "A personal site that's anything but ordinary.",
    description:
      "A personal brand site built like a phone. Visitors can explore your work, find your links, leave a note, and reach your booking calendar—all from one memorable experience.",
    capabilities: [
      "Phone-style lock screen",
      "Live testimonial notifications",
      "Desktop & working dock",
      "Meeting booking calendar",
      "Notes wall & testimonials",
      "Built-in tip jar",
      "Social hub",
      "Writing & projects links",
    ],
    status: "live",
    statusLabel: "Live client site",
    demoUrl: null,
    liveUrl: "https://corysuggs.com",
    backendDemoUrl: null,
    purchaseEligible: true,
    priceOnce: 1500,
    priceMonthly: 150,
    ownerSideCopy:
      "Notes, testimonials, and meeting requests have a clear place to land. The site gives visitors a simple way to connect without sending them through a maze of links.",
    makeYoursCopy:
      "The phone-inspired experience, rebuilt with your name, content, calendar, links, and personality. A personal site that actually feels personal.",
    media: {
      hero: "/api/files/findleyst/uploads/intake/6cc24174-b1bd-4931-8d8f-8f3a67fe1a7d.jpg",
      desktop: "/api/files/findleyst/uploads/intake/4f4a8ff4-a2ba-4092-a091-dfec74a39251.jpg",
      mobile: "/api/files/findleyst/uploads/intake/5ddaf058-3237-41a5-9edd-179db200f40d.jpg",
      video: "/api/files/findleyst/uploads/intake/637978ae-b592-47aa-823d-f60d169d54c5.mp4",
      customer: "/api/files/findleyst/uploads/intake/d35b25fb-5406-4b71-8cbb-aa3787b2ca83.jpg",
      backend: "/api/files/findleyst/uploads/intake/cd34bf5d-b40e-4c21-97ac-6f94180971e3.jpg",
    },
    // Composed showroom stage (real captures only): lock screen + mobile + desktop dock.
    stageMedia: {
      desktop: "/api/files/findleyst/uploads/intake/6cc24174-b1bd-4931-8d8f-8f3a67fe1a7d.jpg",
      mobile: "/api/files/findleyst/uploads/intake/5ddaf058-3237-41a5-9edd-179db200f40d.jpg",
      detail: "/api/files/findleyst/uploads/intake/4f4a8ff4-a2ba-4092-a091-dfec74a39251.jpg",
    },
  },
  {
    slug: "hvac-master",
    order: 25,
    name: "HVAC Brand",
    kind: "template",
    category: "Website + Customer Tool + Business System",
    headline: "Help customers explain the problem before they call.",
    description:
      "A polished HVAC website with an interactive Problem Finder, installation paths, photo-based estimate requests, and tools to manage incoming leads.",
    capabilities: [
      "Premium frontend",
      "Interactive Problem Finder",
      "New-install pathways",
      "Photo estimate intake",
      "Lead management",
      "Guided demo",
    ],
    status: "live",
    statusLabel: "Live working demo",
    demoUrl: "https://lakeside-intake.preview.emergentagent.com/",
    liveUrl: null,
    backendDemoUrl: "https://lakeside-intake.preview.emergentagent.com/portal/login",
    purchaseEligible: true,
    priceOnce: 2500,
    priceMonthly: 250,
    media: {
      hero: "/api/files/findleyst/uploads/intake/fc42c807-665f-49a5-9ce0-07b439f7f37e.jpeg",
      desktop: "/api/files/findleyst/uploads/intake/80915b63-bd7d-4af4-aebf-ceb4daf2bc86.jpeg",
      mobile: "/api/files/findleyst/uploads/intake/8229eb07-7a3d-404c-9541-33fe06365da1.jpeg",
      video: null,
      customer: "/api/files/findleyst/uploads/intake/66fd008b-6fb4-4a04-b014-15efc9edf404.jpeg",
      backend: "/api/files/findleyst/uploads/intake/95313c8f-b860-44d2-b550-23991afe6bc4.jpeg",
    },
    // Composed showroom stage (real captures only): hero + mobile + Problem Finder.
    stageMedia: {
      desktop: "/api/files/findleyst/uploads/intake/fc42c807-665f-49a5-9ce0-07b439f7f37e.jpeg",
      mobile: "/api/files/findleyst/uploads/intake/8229eb07-7a3d-404c-9541-33fe06365da1.jpeg",
      detail: "/api/files/findleyst/uploads/intake/66fd008b-6fb4-4a04-b014-15efc9edf404.jpeg",
    },
  },
  {
    slug: "handled-property",
    order: 20,
    name: "HANDLED Property Co.",
    kind: "custom-system",
    category: "Website + Client Portal + Service System",
    headline: "A website backed by real service tools.",
    description:
      "A property-services experience that goes beyond a service list: guided estimate requests, customer accounts, recurring plans, and a portal for reports, issues, and approvals.",
    capabilities: [
      "Guided photo-estimate intake",
      "Customer accounts & portal",
      "Interactive client property demo",
      "WATCH reports with photo documentation",
      "Issue review & approval loop",
      "Recurring Property Watch plans",
      "Six-step plan onboarding",
      "Scheduling, history & documents",
    ],
    status: "live",
    statusLabel: "Live working demo",
    demoUrl: "https://handledpropertyco.com/",
    liveUrl: null,
    backendDemoUrl: "https://handledpropertyco.com/demo",
    backendDemoLabel: "Explore the Client Demo",
    purchaseEligible: true,
    priceOnce: 5000,
    priceMonthly: 350,
    media: {
      hero: "/api/files/findleyst/uploads/intake/030e9a9e-e9c2-4b69-ab24-e1582fa84e56.jpeg",
      desktop: "/api/files/findleyst/uploads/intake/3fe82bce-68c8-4157-a45a-37c89341d311.jpeg",
      mobile: "/api/files/findleyst/uploads/intake/83f4e8ba-6f16-4859-8832-6848a53e26d1.jpeg",
      video: "/api/files/findleyst/uploads/intake/857cea4c-a4f7-4e2b-a103-c90ffffc6a58.mp4",
      customer: "/api/files/findleyst/uploads/intake/ce325c76-46aa-40ba-9fa9-715e61477ce4.jpeg",
      backend: "/api/files/findleyst/uploads/intake/16ebde62-c401-436e-8450-a9ff7151e5ba.jpeg",
    },
    // Composed showroom stage (real captures only): marketing homepage + mobile + the working dashboard.
    stageMedia: {
      desktop: "/api/files/findleyst/uploads/intake/030e9a9e-e9c2-4b69-ab24-e1582fa84e56.jpeg",
      mobile: "/api/files/findleyst/uploads/intake/83f4e8ba-6f16-4859-8832-6848a53e26d1.jpeg",
      detail: "/api/files/findleyst/uploads/intake/3fe82bce-68c8-4157-a45a-37c89341d311.jpeg",
    },
  },
  {
    slug: "mens-health",
    order: 12,
    name: "Men's Health Brand",
    kind: "custom-system",
    category: "Men's Health Website + Explorer + Patient Portal",
    headline: "Help patients understand their options.",
    description:
      "An interactive men's health experience with a body explorer, guided assessment, service information, consultation booking, and a patient portal concept. Explore the demo to see the experience.",
    capabilities: [
      "Interactive body explorer",
      "7-step health assessment",
      "Four service pathways",
      "Consultation booking",
      "Patient portal with lab trends",
      "Secure messaging",
      "Concierge chat",
      "Educational resource library",
    ],
    status: "live",
    statusLabel: "Live working demo",
    demoUrl: "https://male-health-explorer--1dccafr6.preview.emergentagent.com/",
    liveUrl: null,
    backendDemoUrl: "https://male-health-explorer--1dccafr6.preview.emergentagent.com/demo/portal",
    backendDemoLabel: "Explore the Patient Portal",
    purchaseEligible: true,
    priceOnce: 2500,
    priceMonthly: 250,
    ownerSideCopy:
      "Patients manage appointments, review lab trends and message the care team from one secure portal — while the site educates and qualifies new patients around the clock.",
    makeYoursCopy:
      "Your clinic, your services, your voice — the same interactive explorer, private assessment and patient portal, customized for your practice. This demo's brand stays theirs; the build becomes yours.",
    media: {
      hero: "/api/files/findleyst/uploads/intake/4decd59e-8d10-412d-acfe-55582f4d1b15.jpg",
      desktop: "/api/files/findleyst/uploads/intake/8948296c-cc69-42b7-a278-a1014dde2171.jpg",
      mobile: "/api/files/findleyst/uploads/intake/9784f722-c85d-4b55-9ef3-d557dfe70e22.jpg",
      video: "/api/files/findleyst/uploads/intake/f7d02f27-2688-4226-9cad-44d1ceafb6b2.mp4",
      customer: "/api/files/findleyst/uploads/intake/7cad2ad4-9d2b-4f6e-8e9e-015f84bdfb8e.jpg",
      backend: "/api/files/findleyst/uploads/intake/85f4cc4c-a74c-4b9c-8a38-96d15bf5c18a.jpg",
    },
    // Composed showroom stage (real captures only): hero + mobile + interactive explorer.
    stageMedia: {
      desktop: "/api/files/findleyst/uploads/intake/4decd59e-8d10-412d-acfe-55582f4d1b15.jpg",
      mobile: "/api/files/findleyst/uploads/intake/9784f722-c85d-4b55-9ef3-d557dfe70e22.jpg",
      detail: "/api/files/findleyst/uploads/intake/7cad2ad4-9d2b-4f6e-8e9e-015f84bdfb8e.jpg",
    },
  },
  {
    slug: "holistic-ame",
    order: 15,
    name: "Holistic Brand",
    kind: "template",
    category: "Wellness Website + Booking + Owner Dashboard",
    headline: "A calmer way to explore care—and manage it.",
    description:
      "A wellness website that guides visitors toward the right services and makes booking easy. Behind it, the owner can update content, manage services, and keep track of inquiries.",
    capabilities: [
      "Guided visitor journey",
      "Four service pathways",
      "Embedded online booking",
      "Self-serve content editing",
      "Service management",
      "Inquiry inbox",
      "Photo library",
      "Team access & roles",
    ],
    status: "live",
    statusLabel: "Live working demo",
    demoUrl: "https://holistic-luxe-demo--2lcmmcrm.preview.emergentagent.com/",
    liveUrl: null,
    backendDemoUrl: "https://holistic-luxe-demo--2lcmmcrm.preview.emergentagent.com/admin",
    backendDemoLabel: "Explore the Owner Dashboard",
    purchaseEligible: true,
    priceOnce: 2500,
    priceMonthly: 250,
    ownerSideCopy:
      "The owner can update site content, services, and photos without waiting on a developer. Inquiries and team access are handled from the owner dashboard.",
    makeYoursCopy:
      "Your practice, services, photos, booking setup, and voice—using the same guided experience and owner dashboard, customized to fit your business.",
    media: {
      hero: "/api/files/findleyst/uploads/intake/06a09d78-8c92-421e-bf08-a3ee3689e120.jpg",
      desktop: "/api/files/findleyst/uploads/intake/87ac7552-37a0-44b3-8100-6ca2447c3f2b.jpg",
      mobile: "/api/files/findleyst/uploads/intake/c5b7060f-9b25-4756-82d5-d2726be3e710.jpg",
      video: "/api/files/findleyst/uploads/intake/e53eaaea-48ef-4e1b-9d73-f5fc5a0ed4e8.mp4",
      customer: "/api/files/findleyst/uploads/intake/a0a2c49c-2d68-43dc-9432-f3a41c8b7d71.jpg",
      backend: "/api/files/findleyst/uploads/intake/b9822ca8-1c55-47f0-ad5a-2db08573d531.jpg",
    },
    // Composed showroom stage (real captures only): hero + mobile + owner dashboard.
    stageMedia: {
      desktop: "/api/files/findleyst/uploads/intake/06a09d78-8c92-421e-bf08-a3ee3689e120.jpg",
      mobile: "/api/files/findleyst/uploads/intake/c5b7060f-9b25-4756-82d5-d2726be3e710.jpg",
      detail: "/api/files/findleyst/uploads/intake/b9822ca8-1c55-47f0-ad5a-2db08573d531.jpg",
    },
  },
  {
    slug: "confederate-group",
    order: 30,
    name: "Construction Brand",
    kind: "template",
    category: "Premium Business Website + Estimate Engine",
    headline: "Make a strong impression. Get better inquiries.",
    description:
      "A professional construction website with project galleries, before-and-after examples, clear services, and an estimate request process that lets customers share photos and details.",
    capabilities: [
      "Cinematic editorial design",
      "Interactive before/after showcase",
      "Filterable project gallery",
      "Photo-first estimate intake",
      "Dedicated service pages",
      "Mobile-first conversion",
    ],
    status: "live",
    statusLabel: "Live client site",
    demoUrl: null,
    liveUrl: "https://buildwithcg.com/",
    backendDemoUrl: null,
    purchaseEligible: true,
    priceOnce: 1500,
    priceMonthly: 150,
    ownerSideCopy:
      "Estimate requests can include photos and project details, giving the team useful context before the first conversation.",
    makeYoursCopy:
      "Your name, services, photos, projects, and service area—with the same polished presentation and estimate-request experience tailored to your business.",
    media: {
      hero: "/api/files/findleyst/uploads/intake/5ddaef21-d4ba-419f-b21c-8b76ad33a130.jpeg",
      desktop: "/api/files/findleyst/uploads/intake/e60f2334-25e4-4304-b342-ab1b1ad93296.jpeg",
      mobile: "/api/files/findleyst/uploads/intake/b9e0b77f-5e63-4cd0-b5d9-5211427e0585.jpeg",
      video: "/api/files/findleyst/uploads/intake/891a7c25-bed6-4860-972d-47dea0923228.mp4",
      customer: "/api/files/findleyst/uploads/intake/a56f8c35-d4b7-4af0-8bc5-9cebf20ef182.jpeg",
      backend: "/api/files/findleyst/uploads/intake/580dddc9-26e4-4a58-aa9d-4e80997a3f06.jpeg",
    },
    // Composed showroom stage (real captures only): hero + mobile + before/after.
    stageMedia: {
      desktop: "/api/files/findleyst/uploads/intake/5ddaef21-d4ba-419f-b21c-8b76ad33a130.jpeg",
      mobile: "/api/files/findleyst/uploads/intake/b9e0b77f-5e63-4cd0-b5d9-5211427e0585.jpeg",
      detail: "/api/files/findleyst/uploads/intake/a56f8c35-d4b7-4af0-8bc5-9cebf20ef182.jpeg",
    },
  },
  {
    slug: "findley-st-paint",
    order: 40,
    name: "PaintCo Demo",
    kind: "template",
    category: "Painting Website + Color Studio + Command Center",
    headline: "Let customers picture the finished job.",
    description:
      "A painting website with an interactive color studio where visitors can try room colors, plus estimate intake and a business command center for leads, projects, and scheduling.",
    capabilities: [
      "Interactive color studio",
      "Live room repaint preview",
      "Guided project intake",
      "Lead inbox & pipeline",
      "Estimate builder & tracking",
      "Crew scheduling & projects",
      "Business reporting",
    ],
    status: "live",
    statusLabel: "Live working demo",
    demoUrl: "https://abe-command-center.preview.emergentagent.com/",
    liveUrl: null,
    backendDemoUrl: "https://abe-command-center.preview.emergentagent.com/command",
    backendDemoLabel: "Explore the Command Center",
    purchaseEligible: true,
    priceOnce: 2500,
    priceMonthly: 250,
    makeYoursCopy:
      "Your painting business, your branding, and your services—with the color studio and business tools adapted to your workflow.",
    media: {
      hero: "/api/files/findleyst/uploads/intake/76ded3bb-31d6-43fe-87b7-aa4bc4e367c2.jpeg",
      desktop: "/api/files/findleyst/uploads/intake/771bacf1-1fe5-44c7-9a50-ce3ce887818a.jpeg",
      mobile: "/api/files/findleyst/uploads/intake/c2b63f5b-b4a1-41c4-a4bb-9632ec640d7d.jpeg",
      video: "/api/files/findleyst/uploads/intake/dcb56fc8-7b6e-4570-91f4-5fc0c0fa865f.mp4",
      customer: "/api/files/findleyst/uploads/intake/3d6b72d7-e44e-4308-a81c-d876dfb162c2.jpeg",
      backend: "/api/files/findleyst/uploads/intake/33c3fbe0-2512-4768-9a67-6b10b259b637.jpeg",
    },
    // Composed showroom stage (real captures only): hero + mobile + command center.
    stageMedia: {
      desktop: "/api/files/findleyst/uploads/intake/76ded3bb-31d6-43fe-87b7-aa4bc4e367c2.jpeg",
      mobile: "/api/files/findleyst/uploads/intake/c2b63f5b-b4a1-41c4-a4bb-9632ec640d7d.jpeg",
      detail: "/api/files/findleyst/uploads/intake/4be3d741-4fcc-436d-8c57-d8c41cf4a54c.jpeg",
    },
  },
  {
    slug: "gutter-solutions",
    order: 50,
    name: "Gutter Solutions",
    kind: "template",
    category: "Local Business Website + Estimate System",
    headline: "A professional site that helps win the next job.",
    description:
      "A straightforward business website with clear services, trust-building details, and a photo-based estimate request. Proof that useful doesn't have to mean complicated.",
    capabilities: [
      "Responsive design",
      "Service presentation",
      "Photo estimate intake",
      "Lead capture",
      "Social proof",
      "Conversion-focused CTAs",
    ],
    status: "live",
    statusLabel: "Live client site",
    demoUrl: null,
    liveUrl: "https://guttersolutionsoklahoma.com",
    backendDemoUrl: null,
    purchaseEligible: true,
    priceOnce: 1000,
    priceMonthly: 150,
    media: {
      hero: "/api/files/findleyst/uploads/intake/4474932d-0344-4f88-8779-479b0e869573.jpeg",
      desktop: "/api/files/findleyst/uploads/intake/f2c5c2e0-3bd9-4d7f-ae4e-e7cea86b3e31.jpeg",
      mobile: "/api/files/findleyst/uploads/intake/f3b5d9bc-fbf6-481f-a4a3-db542c48ec69.jpeg",
      video: "/api/files/findleyst/uploads/intake/61368cea-698e-4276-95f3-4e8df844864b.mp4",
      customer: "/api/files/findleyst/uploads/intake/788687ee-26eb-4b6b-9b51-6b6bc73444e2.jpeg",
      backend: null,
    },
    ownerSideCopy:
      "Customers can send photos and job details with their estimate request, so the business has useful information before following up.",
    // Composed showroom stage (real captures only): hero + mobile + estimate flow.
    stageMedia: {
      desktop: "/api/files/findleyst/uploads/intake/4474932d-0344-4f88-8779-479b0e869573.jpeg",
      mobile: "/api/files/findleyst/uploads/intake/f3b5d9bc-fbf6-481f-a4a3-db542c48ec69.jpeg",
      detail: "/api/files/findleyst/uploads/intake/788687ee-26eb-4b6b-9b51-6b6bc73444e2.jpeg",
    },
  },
];

export const SHOWROOM = PROJECTS.filter((p) => p.status !== "in-preparation").sort(
  (a, b) => a.order - b.order
);
export const getProject = (slug) => PROJECTS.find((p) => p.slug === slug);
export const nextProject = (slug) => {
  const i = SHOWROOM.findIndex((p) => p.slug === slug);
  return i >= 0 ? SHOWROOM[(i + 1) % SHOWROOM.length] : null;
};
